var React = require('react');

function BadgeIconPlus (props) {
    return React.createElement("svg",props);
}

BadgeIconPlus.defaultProps = {};

module.exports = BadgeIconPlus;

BadgeIconPlus.default = BadgeIconPlus;
